module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306099.c2e38044.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSat/FormatoSimplificado_306099.pdf
// module id = 331
// module chunks = 0